module.exports = __webpack_public_path__ + "static/media/HowItWorkImage2.b17e1989.jpeg";